import React from 'react';
import { motion } from 'framer-motion';
import { Code, Cpu, Wrench } from 'lucide-react';

const Competences = ({ competences }) => {
  return (
    <section id="compétences" className="py-20 section-spacing">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="bg-violet-600/20 p-3 rounded-full">
            <Code className="text-violet-400" size={28} />
          </div>
          <div>
            <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-1">Compétences</h2>
            <div className="text-xs font-mono text-gray-500">$ skills --list</div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 ">
          {/* Langages */}
          <div className="bg-dark-surface rounded-xl p-6 border border-violet-500/20">
            <h3 className="text-lg font-bold text-violet-400 mb-6 flex items-center gap-2 font-mono">
              <Code size={18} /> Langages
            </h3>
            <div className="space-y-4">
              {competences.langages.map((lang, index) => (
                <div key={index}>
                  <div className="flex justify-between mb-1 font-mono text-sm">
                    <span className="text-gray-300">{lang.name}</span>
                    <span className="text-violet-400">{lang.level}%</span>
                  </div>
                  <div className="w-full bg-dark-bg rounded-full h-1.5 overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: `${lang.level}%` }}
                      transition={{ duration: 1, delay: index * 0.1 }}
                      className="h-full bg-gradient-to-r from-violet-500 to-blue-500 rounded-full"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Concepts */}
          <div className="bg-dark-surface rounded-xl p-6 border border-violet-500/20 section-spacing">
            <h3 className="text-lg font-bold text-violet-400 mb-6 flex items-center gap-2 font-mono">
              <Wrench size={18} /> Outils & Concepts
            </h3>
            <div className="flex flex-wrap gap-2">
              {competences.concepts.map((concept, index) => (
                <motion.span
                  key={index}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: index * 0.05 }}
                  className="px-3 py-1.5 bg-violet-900/20 text-violet-300 rounded-full text-xs font-mono border border-violet-700/30 hover:bg-violet-900/40 transition-colors cursor-default"
                >
                  {concept}
                </motion.span>
              ))}
            </div>

            {/* Stats supplémentaires */}
            <div className="mt-6 pt-6 border-t border-dark-border">
              <div className="grid grid-cols-2 gap-3 text-center">
                <div>
                  <div className="text-2xl font-bold text-blue-400">5+</div>
                  <div className="text-xs text-gray-500 font-mono">ans d'études</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-green-400">∞</div>
                  <div className="text-xs text-gray-500 font-mono">curiosité</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Competences;